/** Default analytics time zone (ADR: workspace default). Day buckets are calendar days in this zone. */
export const ANALYTICS_TZ = "Asia/Baghdad";

const DAY_MS = 86_400_000;

/** `YYYY-MM-DD` of `date` as seen in `timeZone` (never the UTC date, which is wrong 21:00–24:00 UTC). */
export function isoDayInZone(date: Date, timeZone: string = ANALYTICS_TZ): string {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(date);
}

/** Inclusive range ending today (in the zone) and starting `days - 1` days earlier. */
export function lastDaysRange(
  days: number,
  now: Date = new Date(),
  timeZone: string = ANALYTICS_TZ,
): { from: string; to: string } {
  return {
    from: isoDayInZone(new Date(now.getTime() - (days - 1) * DAY_MS), timeZone),
    to: isoDayInZone(now, timeZone),
  };
}

const csvCell = (v: string | number): string => {
  // Neutralise spreadsheet formulas, then quote when needed.
  const s = String(v);
  const safe = /^[=+\-@\t\r]/.test(s) && Number.isNaN(Number(s)) ? `'${s}` : s;
  return /[",\n\r]/.test(safe) ? `"${safe.replaceAll('"', '""')}"` : safe;
};

/** RFC 4180 CSV (CRLF) from a header row and data rows. */
export function toCsv(header: readonly string[], rows: readonly (readonly (string | number)[])[]) {
  return [header, ...rows].map((r) => r.map(csvCell).join(",")).join("\r\n");
}
